// extracted by mini-css-extract-plugin
export var card = "_ac-0";
export var expandedCard = "_ac-2";
export var paginated = "_ac-1";